import { SagaIterator } from 'redux-saga'
import { put, takeLatest, select, all, delay, call } from 'redux-saga/effects'

import { getSelectedUser } from '@tabeeb/modules/presentation/selectors'
import { gridViewSelectors } from '@tabeeb/modules/gridView'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'
import * as accountSelectors from '@tabeeb/modules/account/selectors'
import * as galleryActions from '@tabeeb/modules/gallery/actions'
import * as snapshotActions from '../actions/snapshot'

import { takeUserVideoSnapshot } from '../services/snapshotService'

import { SnapshotResponseDelay } from '../common/snapshot'
import { getIsSnapshotInProgress } from '../selectors'

function* onSnapshotRequestReceived({
  payload: [
    {
      attributes: { targetUserId },
    },
  ],
}: ReturnType<typeof snapshotActions.onSnapshotRequestReceived>): SagaIterator {
  const selectedUser: ReturnType<typeof getSelectedUser> = yield select(getSelectedUser)

  const currentUserId: ReturnType<typeof accountSelectors.getCurrentUserId> = yield select(
    accountSelectors.getCurrentUserId
  )
  const isGridView: ReturnType<typeof gridViewSelectors.getIsGridViewActive> = yield select(
    gridViewSelectors.getIsGridViewActive
  )
  const contentId: ReturnType<typeof getContentId> = yield select(getContentId)

  if (currentUserId === parseInt(targetUserId, 10)) {
    const blob: Awaited<ReturnType<typeof takeUserVideoSnapshot>> = yield call(
      takeUserVideoSnapshot,
      currentUserId,
      selectedUser,
      isGridView
    )
    if (!blob) {
      return
    }

    const files: File[] = [new File([blob], 'snapshot.jpg', { lastModified: Date.now() })]
    yield put(galleryActions.addGallerySnapshotsUploadFiles({ files, ignoreFileUploads: true, contentId }))
  }
}

function* onSnapshotTaking(): SagaIterator {
  yield put(snapshotActions.onSnapshotProgressStateUpdate(true))

  yield delay(SnapshotResponseDelay)

  const snapshotInProgress: ReturnType<typeof getIsSnapshotInProgress> = yield select(getIsSnapshotInProgress)
  if (snapshotInProgress === true) {
    yield put(snapshotActions.onSnapshotProgressStateUpdate(false))
  }
}

function* onSnapshotCreated(): SagaIterator {
  yield put(snapshotActions.onSnapshotProgressStateUpdate(false))
}

function* snapshotSaga() {
  yield all([
    takeLatest(snapshotActions.onSnapshotRequestReceived, onSnapshotRequestReceived),
    takeLatest(snapshotActions.onSnapshotTaking, onSnapshotTaking),
    takeLatest(snapshotActions.onSnapshotCreated, onSnapshotCreated),
  ])
}

export default snapshotSaga
